// TODO: file should be renamed to follow naming conventions

export function hexDecode(hexEncodedData: string): ArrayBuffer {
  const arrBuf = new ArrayBuffer(hexEncodedData.length / 2);
  const buffer = new Uint8Array(arrBuf);
  for (let i = 0; i < hexEncodedData.length / 2; ++i) {
    buffer.set([parseInt(hexEncodedData.substr(i * 2, 2), 16)], i);
  }
  return arrBuf;
}

export function hexEncode(buffer: ArrayBuffer | Uint8Array): string {
  return new Uint8Array(buffer).reduce(
    (str, byte) => str + byte.toString(16).padStart(2, "0"),
    "",
  );
}

export async function orchid_decode_key(
  hex_encoded_key: string,
): Promise<CryptoKey> {
  const raw_data = hexDecode(hex_encoded_key);
  return window.crypto.subtle.importKey("raw", raw_data, "AES-GCM", false, [
    "encrypt",
    "decrypt",
  ]);
}

export async function orchidEncryptBinary(
  inputData: ArrayBuffer,
  cipherKey: CryptoKey,
): Promise<ArrayBuffer> {
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    cipherKey,
    inputData,
  );
  return new Uint8Array([...iv, ...new Uint8Array(encrypted)]);
}

export async function orchidDecryptBinary(
  encryptedData: ArrayBuffer,
  cipherKey: CryptoKey,
): Promise<ArrayBuffer> {
  const iv = encryptedData.slice(0, 12);
  const ecryptedData = encryptedData.slice(12);
  const clearData = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    cipherKey,
    ecryptedData,
  );
  return clearData;
}

// TODO: to be renamed to orchidEncryptText to follow naming conventions
export async function orchid_encrypt(
  inputText: string,
  cipherKey: CryptoKey,
): Promise<string> {
  const enc = new TextEncoder();
  const inputData = enc.encode(inputText);
  return hexEncode(await orchidEncryptBinary(inputData, cipherKey));
}

// TODO: to be renamed to orchidDecryptText to follow naming conventions
export async function orchid_decrypt(
  encryptedText: string,
  cipherKey: CryptoKey,
): Promise<string> {
  const encryptedData = hexDecode(encryptedText);
  const clearData = await orchidDecryptBinary(encryptedData, cipherKey);
  const enc = new TextDecoder();
  return enc.decode(clearData);
}
